
    
const theme = {
    legend: {
        backgroundColor: 'rgba(255,255,255, 0.8)'
    },
};

export const whiteTheme = theme; 
